import React, {useEffect, useState} from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddMembershipGroup } from "./FormAddMembershipGroup";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";

export const AddMembershipGroup = () => {
    const [isGroupsLoading, setIsGroupsLoading] = useState(true);
    const [groups, setGroups] = useState([]);

    const getGroups = async () => {
        setIsGroupsLoading(true);
        const {response} = await Helper.Get({
            url: api_Routes.MembershipGroup.ViewAll,
            hasToken: true,
        });
        if (response) {
            setGroups(response?.data);
        }
        setIsGroupsLoading(false);
    };

    useEffect(() => {
        getGroups();
    }, []);
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Membership Group</div>
          </div>
        }
      />
      <PanelBody content={<FormAddMembershipGroup groups={groups} isGroupsLoading={isGroupsLoading}/>} />
    </div>
  );
};
